import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

interface EfTitleProps {
    /**
     * 是否开启进场动画
     */
    hasAnimation?: boolean;

    /**
     * 主题色
     */
    theme?: 'black' | 'white';

    /**
     *
     * 进场动画是否已启动
     */
    animationEnterCallback?: () => void;

    /**
     * 样式名
     */
    className?: string;
    /**
     * 子内容
     */
    children: React.ReactNode;
}

/**
 * 维护:谢保林
 *
 * 主标题
 */
const EfTitle: React.FC<EfTitleProps> = ({ theme = 'white', hasAnimation = true, animationEnterCallback, className, children }) => {
    const refTitle = useRef(null);
    const [isEnter, setIsEnter] = useState(false);
    const prefixCls = `ef-title`;
    const classes = classNames(prefixCls, `${prefixCls}-${theme}`, {
        [`${className}`]: className,
        [`${prefixCls}-animation`]: hasAnimation,
        [`${prefixCls}-enter`]: isEnter,
    });

    useEffect(() => {
        const observer = new IntersectionObserver(
            (elems: any) => {
                const elem = elems[0];
                const topNum = elem.boundingClientRect.top;
                if (elem.isIntersecting && topNum > 0) {
                    setIsEnter(true);
                    animationEnterCallback && animationEnterCallback();
                }
            },
            {
                rootMargin: `0px 0px -50px 0px`,
                threshold: 0,
            },
        );
        observer.observe(refTitle.current as any);
    }, []);

    return (
        <div className={classes} ref={refTitle}>
            {children}
        </div>
    );
};

export default EfTitle;
